import {cx} from "@emotion/css";

import {ReactComponent as SvgImageIcon} from "~/assets/svg/image.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmImageIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgImageIcon id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
